import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 20_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

export const adminKeys = {
  all: ["admin"] as const,
  overview: () => [...adminKeys.all, "overview"] as const,
  activity: () => [...adminKeys.all, "activity"] as const,
  retreats: () => [...adminKeys.all, "retreats"] as const,
  retreatRegistrations: (retreatId: string) =>
    [...adminKeys.retreats(), retreatId, "registrations"] as const,
  registrationsRoot: () => [...adminKeys.all, "registrations"] as const,
  registrations: (retreatId?: string | null) =>
    [...adminKeys.registrationsRoot(), retreatId ?? "all"] as const,
  sales: () => [...adminKeys.all, "sales"] as const,
};
